import React, { useState, useRef, useEffect, useContext } from "react";
import { useHistory, NavLink } from "react-router-dom";
import { Grid, Image, Icon, } from 'semantic-ui-react'
import moment from "moment";
import "./Contesthistory.scss";
import atar_logo from "../../assets/home/atar_logo.png";
import { Config } from "../../common"
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from 'react-redux'
import right from "../../assets/right.svg";
import worng from "../../assets/worng.svg";
import { getSingleOrders } from '../../store/OrderRedux'
import { clearTrivia } from '../../store/TriviaRedux'
import { StarButton, Loading } from '../../components'

const ContesthistoryScreen = (props) => {
  const { match } = props;
  const history = useHistory();
  const dispatch = useDispatch()
  const { t, i18n } = useTranslation();
  const token = useSelector((state) => state.auth.token)
  const orderDetails = useSelector((state) => state.order.orderDetails)
  const isFetching = useSelector((state) => state.order.isFetching)
  useEffect(() => {
    window.scrollTo(0, 0)
  }, []);
  useEffect(() => {
    if (match.params.id) {
      dispatch(getSingleOrders({ id: match.params.id, token }))
    }
  }, [match]);

  let contestant = orderDetails?.contestant ? orderDetails?.contestant : {}
  let questionBank = contestant?.questionBank ? contestant?.questionBank : []
  let newDate = moment.utc(Config.localUtc()) - moment.utc(orderDetails?.triviaId?.resultDate)

  if (isFetching) {
    return <Loading />
  }

  return (
    <div className="Contesthistory_sec">
      <div className="Contesthistory_img">
        <NavLink
          to="">
          <img src={atar_logo} />
        </NavLink>
      </div>

      <h4>Contest history</h4>
      {questionBank.map((item, key) => {
        let itemDetails = Config.GetLanguageSameLine(item, i18n.language)
        let correct = itemDetails.options.find(x => x.correct)
        let selected = itemDetails.options.find(x => x.selected)
        return <div key={key} className={item.correct ? "Correct" : "released"}>
          <p>Q {key + 1}. {itemDetails.statement}</p>
          <div className="history_top">
            {(correct.correct != correct.selected) && (<div className="baazigar">
              <Image src={worng} />
              <h6>Your answer :  {selected?.value}</h6>
            </div>)}
            <div className="ashna">
              <Image src={right} />
              <h6>Correct answer :  {correct?.value}</h6>
            </div>
          </div>
        </div>
      })}

      <div className="try_pag">

        <div className="Return_to">
          <button className="try" onClick={() => { dispatch(clearTrivia()); history.push(`/`) }}>{t("myorder.btn")}</button>
        </div>

        {(orderDetails && orderDetails?.triviaId?.status == 'completed' && newDate > 0) && (<div className="Return_to">
          <StarButton background={'mainBg'} title={t("leaderboard.title")} onClickAction={() => history.push(`/leaderboard/${orderDetails?.triviaId?._id}`)} />
        </div>)}

        {(orderDetails && orderDetails?.triviaId?.status == 'ongoing') && (<div className="Return_to">
          <StarButton background={'mainBg'} title={t("notifiction.btn5")} onClickAction={() => history.push(`/payment`)} />
        </div>)}


      </div>

    </div>
  );
};

export default ContesthistoryScreen
